import React, { useEffect } from "react";
import BreadCrumb from "../BreadCrumb";
import "./declaration.css";

// Shared shell for the three declaration / terms pages. Content is passed in
// as children so each declaration keeps its own text.
export default function DeclarationLayout({ title, subtitle, crumbLabel, children }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const breadcrumbs = [{ path: "/", label: "Home" }, { label: crumbLabel }];

  return (
    <div className="lists-box declaration-page">
      <div className="container">
        <BreadCrumb crumbs={breadcrumbs} />
        <div className="declaration-box">
          <h1>{title}</h1>
          {subtitle ? <div className="decl-sub">{subtitle}</div> : null}
          {children}
        </div>
      </div>
    </div>
  );
}

// Small helper so each point renders consistently (English + optional Hindi).
export function Point({ heading, en, hi }) {
  return (
    <div className="decl-point">
      {heading ? <h3>{heading}</h3> : null}
      {en ? <p>{en}</p> : null}
      {hi ? <p className="hi">{hi}</p> : null}
    </div>
  );
}
